import { RootState, StoreThunkDispatch } from 'RootTypes';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useTypedDispatch = () => useDispatch<StoreThunkDispatch>();
